const EXTRA_SCROLL = -50;

export const scrollTo = (ref) => window.scrollTo(0, ref && ref.current ? ref.current.offsetTop + EXTRA_SCROLL : null);
